import api from '@app/utils/api';

export const fetchCorporateStructure = () => {
  return api.get('/executive/corporates/structure');
};
